import React from 'react'

import Duration from './Duration'

import type { IDurationProps } from './Duration'


import { tw } from 'tagged-classnames-free';
export interface IToggleComponentProps {
  className?: string
  durationProps: IDurationProps
}

const ToggleComponent: React.FC<IToggleComponentProps> = (props) => {
  const { className, durationProps } = props
  return (
    <div
      className={tw`
        mx-auto mb-8 flex items-center  justify-center gap-x-2
        ${className}
      `}
    >
      <Duration {...durationProps} />
    </div>
  )
}

export default ToggleComponent
